// "Submit for approval": pick which companies should review this version.

import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import { getTemplateCompanies } from "../Components/templateApi";

export default function SubmitModal({ isOpen, onClose, onSubmit, approvals, warnings }) {
  const [companies, setCompanies] = useState(null);
  const [picked, setPicked] = useState({});
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    let alive = true;
    setCompanies(null);
    getTemplateCompanies()
      .then((list) => {
        if (!alive) return;
        setCompanies(list || []);
        const all = {};
        (list || []).forEach((c) => (all[c._id] = true));
        setPicked(all);
      })
      .catch(() => alive && setCompanies([]));
    return () => {
      alive = false;
    };
  }, [isOpen]);

  const chosen = Object.keys(picked).filter((k) => picked[k]);
  const statusOf = (id) => (approvals || []).find((a) => String(a.companyId) === String(id));

  return (
    <Modal isOpen={isOpen} toggle={onClose} centered>
      <ModalHeader toggle={onClose}>Submit for approval</ModalHeader>
      <ModalBody>
        <p className="td-modal__lead">
          The company checks your template once. When they approve it, your invoices for them are created from this
          template automatically — no more uploading an invoice file. Until then, invoices work as they do today.
        </p>
        {warnings > 0 && (
          <p className="td-modal__warn">
            <FeatherIcon icon="alert-triangle" size={14} /> There {warnings === 1 ? "is 1 warning" : `are ${warnings} warnings`} in Checks. You can still submit.
          </p>
        )}
        {companies === null && <p className="td-hint">Loading companies…</p>}
        {companies && !companies.length && <p className="td-hint">You aren't set up to invoice any company yet.</p>}
        {companies && companies.length > 0 && (
          <fieldset className="td-fieldset">
            <legend className="td-label">Send to</legend>
            {companies.map((c) => {
              const st = statusOf(c._id);
              return (
                <label key={c._id} className="td-check">
                  <input type="checkbox" checked={!!picked[c._id]} onChange={(e) => setPicked((p) => ({ ...p, [c._id]: e.target.checked }))} />
                  <span>{c.name}</span>
                  {st && <span className="td-hint"> — currently {st.status.replace("_", " ")}{st.approvedVersion ? `, v${st.approvedVersion} approved` : ""}</span>}
                </label>
              );
            })}
          </fieldset>
        )}
      </ModalBody>
      <ModalFooter>
        <button type="button" className="td-btn td-btn--ghost" onClick={onClose}>
          Cancel
        </button>
        <button
          type="button"
          className="td-btn td-btn--primary"
          disabled={busy || !chosen.length}
          onClick={async () => {
            setBusy(true);
            try {
              await onSubmit(chosen);
            } finally {
              setBusy(false);
            }
          }}
        >
          <FeatherIcon icon={busy ? "loader" : "send"} size={14} className={busy ? "td-spin" : ""} /> Submit
        </button>
      </ModalFooter>
    </Modal>
  );
}
